import React from 'react';

import {useTranslation} from 'react-i18next';

import {Input, InputProps} from 'components/ui-kit/Input';

import {Label} from '../Label';

import {RangeInputContainer, RangeSeparator} from './styled';

type ValuePair = [string | null, string | null];

interface Props {
    value?: ValuePair;
    onChange?: (value: ValuePair | undefined) => void;
    label?: string;
    hasError?: boolean;
    fromFieldProps?: InputProps;
    toFieldProps?: InputProps;
    formFieldName?: string;
}

export const NumberRange = ({
    value,
    onChange,
    hasError,
    fromFieldProps,
    toFieldProps,
    label,
}: Props) => {
    const {t} = useTranslation();
    const valueFrom = value ? (value[0] == null ? '' : value[0]) : '';
    const valueTo = value ? (value[1] == null ? '' : value[1]) : '';
    const onValueChange = (value: string, index: 0 | 1) => {
        if (!onChange) {
            return;
        }

        const result = (index === 0 ? [value, valueTo] : [valueFrom, value]).map((elem) =>
            elem === '' ? null : elem,
        ) as ValuePair;
        onChange(result.every((elem) => elem == null) ? undefined : result);
    };

    if (fromFieldProps == null) {
        fromFieldProps = {};
    }

    if (toFieldProps == null) {
        toFieldProps = {};
    }

    if (!fromFieldProps.placeholder) {
        fromFieldProps.placeholder = t('components.numberRange.from');
    }

    if (!toFieldProps.placeholder) {
        toFieldProps.placeholder = t('components.numberRange.to');
    }

    return (
        <Label text={label} hasError={hasError}>
            <RangeInputContainer>
                <Input
                    {...fromFieldProps}
                    value={valueFrom}
                    onChange={(e) => onValueChange(e.target.value, 0)}
                    hasError={hasError}
                    type="number"
                />
                <RangeSeparator />
                <Input
                    {...toFieldProps}
                    value={valueTo}
                    onChange={(e) => onValueChange(e.target.value, 1)}
                    hasError={hasError}
                    type="number"
                />
            </RangeInputContainer>
        </Label>
    );
};
